<template>
  <section id="skill" >
    <div class="container col-xl-12 col-xxl-12">
    <div class="row row-cols-2 row-cols-lg-4 g-2 g-lg-3">
      <div class="col ">
        <div class="p-2 border text-center">
          <div><img src="https://www.rimborsoalvolo.it/cresources/outform/images/reclami.png"></div>
          <div class="skillTxt" ><span class="count" id="countreclami">99</span><span>%</span></div>
          <div class="skillTitle">RECLAMI VINTI</div>
        </div>
      </div>
      <div class="col ">
        <div class="p-2 border text-center">
          <div><img src="https://www.rimborsoalvolo.it/cresources/outform/images/esperti.png"></div>
          <div class="skillTxt"><span class="count" id="countesperti"> 30</span><span>+</span></div>
          <div class="skillTitle">ESPERTI</div>
        </div>
      </div>
      <div class="col ">
        <div class="p-2 border text-center">
          <div><img src="https://www.rimborsoalvolo.it/cresources/outform/images/passeggeri.png"></div>
          <div class="skillTxt"><span class="count" id="countpasseggeri">300</span><span>k</span></div>
          <div class="skillTitle">PASSEGGERI AIUTATI</div>
        </div>
      </div>
      <div class="col ">
        <div class="p-2 border text-center">
          <div><img src="https://www.rimborsoalvolo.it/cresources/outform/images/rimborsi.png"></div>
          <div class="skillTxt"><span class="count" id="countrimborsi">30</span><span>M</span></div>
          <div class="skillTitle" ref="target">RIMBORSI OTTENUTI</div>
        </div>
      </div>
    </div>
    </div>
  </section>
</template>


<script>
import { onMounted } from 'vue';
import { ref } from 'vue';
import { useElementVisibility} from "@vueuse/core";
import moment from "moment/moment";

export default {
  name: "ConteggioReclami",
  setup(){
    const target = ref(null);
    const s_visibile = useElementVisibility(target);
    return {
      target,
      s_visibile,
    }
  },
  data(){
    return {
      reclamiVisibili : this.s_visibile
    }
  },
  watch:{
    s_visibile:function(value){
      if(!value) {
        document.getElementById('countreclami').textContent = 99;
        document.getElementById('countesperti').textContent = 30;
        document.getElementById('countpasseggeri').textContent = 300;
        document.getElementById('countrimborsi').textContent = 30;
        return;
      }
      jQuery('.count').each(function() {
        let $this = $(this);
        jQuery({
          Counter: 0
        }).animate({
          Counter: $this.text().replace(/,/g, '')
        }, {
          duration: 1000,
          easing: 'swing',
          step: function() {
            $this.text(commaSeparateNumber(Math.floor(this.Counter)));
          },
          complete: function() {
            $this.text(commaSeparateNumber(this.Counter));
            //alert('finished');
          }
        });
      });

      function commaSeparateNumber(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

    }
  },
}
</script>

<style scoped>

</style>